import { forwardRef } from "react";
import type { InputHTMLAttributes, ReactNode } from "react";
import "./Switch.css";

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size" | "type"> {
  label?: ReactNode;
}

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(" ");

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { label, className, disabled, id, ...rest },
  ref,
) {
  return (
    <label className={cx("go4-switch", disabled && "go4-switch--disabled", className)}>
      <input
        ref={ref}
        id={id}
        type="checkbox"
        role="switch"
        disabled={disabled}
        className="go4-switch__input"
        {...rest}
      />
      <span className="go4-switch__track" aria-hidden="true">
        <span className="go4-switch__thumb" />
      </span>
      {label ? <span className="go4-switch__label">{label}</span> : null}
    </label>
  );
});
